import axios from "axios";
import { BASE_URL } from "./baseUrl";
import { getClientSource } from "./Functions";

const authHeaders = () => {
  const accessToken = localStorage.getItem("accessToken");
  return {
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    company_source: getClientSource(),
  };
};

export const FILE_TYPE_OPTIONS = [
  { value: "env", label: "ENV file" },
  { value: "pem", label: "PEM / certificate" },
  { value: "postman", label: "Postman collection (JSON)" },
  { value: "other", label: "Other" },
];

export const FILE_TYPE_ACCEPT = {
  env: ".env,.env.*",
  pem: ".pem,.key,.crt,.cer",
  postman: ".json,application/json",
  other: ".env,.pem,.key,.crt,.json,.txt,.yaml,.yml,.ini,.config,.conf,.xml,.properties,.toml",
};

export const FILE_TYPE_LABELS = {
  env: "ENV",
  pem: "PEM",
  postman: "Postman",
  other: "Other",
};

export async function downloadProjectCredentialFile({ projectId, fileId, fileName, sharedWithMe = false }) {
  const url =
    sharedWithMe || !projectId
      ? `${BASE_URL}/api/project-credentials/files/${fileId}/download`
      : `${BASE_URL}/api/project-credentials/project/${projectId}/files/${fileId}/download`;

  const res = await axios.get(url, {
    responseType: "arraybuffer",
    headers: authHeaders(),
    validateStatus: () => true,
  });

  if (res.status === 401) {
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }

  if (res.status !== 200) {
    throw new Error("Could not download the file.");
  }

  const contentType = res.headers["content-type"] || "application/octet-stream";
  const blob = new Blob([res.data], { type: contentType });
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = fileName || "download";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
}
